document.addEventListener("DOMContentLoaded", function () {
  const allElements = document.querySelectorAll('.fade-in-down');

  // Group fade-in elements by closest parent (assumes sibling elements are grouped)
  const parentMap = new Map();

  allElements.forEach(el => {
    const parent = el.parentElement;
    if (!parentMap.has(parent)) {
      parentMap.set(parent, []);
    }
    parentMap.get(parent).push(el);
  });

  // Set up observer for each parent group
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const group = parentMap.get(entry.target);
        if (group) {
          group.forEach((el, i) => {
            setTimeout(() => {
              el.classList.add("visible");
            }, i * 150);
          });
        }
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  // Observe each parent that contains fade-in-down elements
  parentMap.forEach((_, parent) => {
    observer.observe(parent);
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll('.fade-in-down-stagger, .impact-number'); // Combined elements
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.3
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        const target = entry.target;

        // Handle fade-in-down-stagger animation
        if (target.classList.contains('fade-in-down-stagger')) {
          setTimeout(() => {
            target.classList.add('show');
          }, index * 400); // staggered effect
        }

        // Handle count-up animation
        if (target.classList.contains('impact-number')) {
          const targetNumber = parseInt(target.getAttribute('data-count'), 10);
          const duration = 500; // 2 seconds duration
          let start = 0;
          const increment = targetNumber / (duration / 16.6667); // Smooth increment based on 60fps

          function countUp() {
            start += increment;
            if (start >= targetNumber) {
              target.textContent = targetNumber.toLocaleString();
            } else {
              target.textContent = Math.ceil(start).toLocaleString();
              requestAnimationFrame(countUp);
            }
          }
          requestAnimationFrame(countUp); // Start counting
        }

        observer.unobserve(target); // Stop observing the current element
      }
    });
  }, observerOptions);

  // Start observing combined elements
  elements.forEach(element => observer.observe(element));
});

jQuery(document).ready(function($){

// Ensure jQuery is available
    $(document.body).on('click', '.cite-copy', function(e) {
        e.preventDefault();

         var content = $(this).parent().parent().find('.cite-popup').text();
    // Create a temporary textarea element to hold the text to copy
    var tempElement = $('<textarea>');
    $('body').append(tempElement);

    // Set the text of the textarea to the content
    tempElement.val(content).select();

    // Copy the content to the clipboard
    document.execCommand('copy');

    // Remove the temporary element
    tempElement.remove();

     // Show the popup
    var popup = $('#copy-popup');
    popup.fadeIn(200);  // Fade in the popup over 200ms

    // Hide the popup after 2 seconds (2000ms)
    setTimeout(function() {
        popup.fadeOut(200);  // Fade out the popup over 200ms
    }, 2000);
    });

    $(document.body).on('click', '.link-cite', function(e) {

      e.preventDefault();
$(this).addClass('active');

$(this).find('.publication-cite-popup').show();
});

   $(document.body).on('click', '.link-share', function(e) {
          e.preventDefault();

$(this).addClass('active');

$(this).find('.publication-share-popup').show();
});

$(document).on('click', function (event) {
    // Check if the clicked target is not inside .publication-cite-popup and it's not the .link-cite
    if (!$(event.target).closest('.publication-cite-popup, .link-cite').length) {
        // Hide .publication-cite-popup
        $('.publication-cite-popup').hide();

        // Remove the 'active' class from .link-cite
        $('.link-cite').removeClass('active');
    }
});

$(document).on('click', function (event) {
    // Check if the clicked target is not inside .publication-cite-popup and it's not the .link-cite
    if (!$(event.target).closest('.publication-share-popup, .link-share').length) {
        // Hide .publication-cite-popup
        $('.publication-share-popup').hide();

        // Remove the 'active' class from .link-cite
        $('.link-share').removeClass('active');
    }
});

});



